export const SET_TOUR_VISIBILITY = "SET_TOUR_VISIBILITY";

const requestShowTour = () => ({
  type: SET_TOUR_VISIBILITY,
  tourVisible: true,
});

const requestHideTour = () => ({
  type: SET_TOUR_VISIBILITY,
  tourVisible: false,
});

export const showTour = () => async (dispatch) => {
  dispatch(requestShowTour());
};

export const hideTour = () => async (dispatch) => {
  dispatch(requestHideTour());
};



// WEBPACK FOOTER //
// ./src/actions/tour.js